import lazyLoadOnRender from '@ms/yammer-web-components/dist/lazy/loadOnRender';
import loading from '@ms/yammer-web-components/dist/navigation/NavigationSpinner';

const appLayoutTemplateLoader = () => import(/* webpackChunkName: "4-page-applayout" */ './AppLayout');

export default lazyLoadOnRender({ loader: appLayoutTemplateLoader, loading });
